import { UntypedFormGroup, Validators } from '@angular/forms';
import { EsgObject } from '../definition/interface/subscription';

export default {
  generatForm(entity: EsgObject, formBuilder): UntypedFormGroup {
    let formBuilderGroup = formBuilder.group({
      ownerId: [entity.ownerId],
      userLastName: [entity?.userLastName || null],
      userFirstName: [entity?.userFirstName || null],
      esgProfil: formBuilder.group({
        includeNonESG: [
          entity?.esgProfil?.includeNonESG || false,
          Validators.required,
        ],
        nonESGInvestments: [entity?.esgProfil?.nonESGInvestments || null],
        investmentsForbiden: [entity?.esgProfil?.investmentsForbiden || null],
        investments: [entity?.esgProfil?.investments || null],
        includeESG: [
          entity?.esgProfil?.includeESG || false,
          Validators.required,
        ],
        taxonomy: [entity?.esgProfil?.taxonomy || '0', Validators.required],
        sustainability: [entity?.esgProfil?.sustainability || '0'],
      }),
    });

    return formBuilderGroup;
  },
};
